import { toast } from '@folio/components';
import { branchControllerInvalidateBranch, policyControllerConfirmPolicy } from 'korint-sdk';
import i18next from 'i18next';
import _ from 'lodash';

export async function confirmMtaPolicy(policyId: string, branchId: string): Promise<void> {
  try {
    await policyControllerConfirmPolicy(policyId, { branchId });
  } catch (error) {
    const errorCode = _.get(error, 'errorResponse.data.code');

    if (errorCode !== 'NO_CHANGES_TO_SIGN') {
      throw error;
    }

    await branchControllerInvalidateBranch(policyId, branchId, {
      reason: 'BROKER_REQUEST',
    });

    toast({
      variant: 'warning',
      title: i18next.t('archive.mtaArchived'),
      description: i18next.t('archive.mtaNoChangesDescription'),
    });
  }
}
